'use client';

import React__default from 'react';

var StatsIcon = function (props) {
    var onClick = props.onClick, _a = props.onMouseOver, onMouseOver = _a === void 0 ? function () { } : _a, _b = props.onMouseLeave, onMouseLeave = _b === void 0 ? function () { } : _b;
    return (React__default.createElement("svg", { width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', onClick: onClick, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave },
        React__default.createElement("path", { d: 'M10.4093 3.99365C9.96773 3.99365 9.60933 4.35205 9.60933 4.79365V18.3937H13.6093V4.79365C13.6093 4.35205 13.2509 3.99365 12.8093 3.99365H10.4093ZM0.809326 5.59365V21.5937H20.8093V19.9937H2.40933V5.59365H0.809326ZM16.0093 5.59365C15.5677 5.59365 15.2093 5.95205 15.2093 6.39365V18.3937H19.2093V6.39365C19.2093 5.95205 18.8509 5.59365 18.4093 5.59365H16.0093ZM4.80933 8.79365C4.36773 8.79365 4.00933 9.15205 4.00933 9.59365V18.3937H8.00933V9.59365C8.00933 9.15205 7.65093 8.79365 7.20933 8.79365H4.80933Z', fill: '#005AFF' })));
};
var StatsIcon$1 = React__default.memo(StatsIcon);

export { StatsIcon$1 as default };
//# sourceMappingURL=index.js.map
